module.exports = __webpack_public_path__ + "media/images/application/template/icon-design-software-924308cff6bc3b732e19a778eff32916.svg";